import React from 'react'
import image from '../../../../Media/TestPics/7.jpg'
import '../Tables.css'
import { NavLink, Link } from 'react-router-dom'

const TableCoursesRow = ({ data }) => {
  if (data.completed_tests > data.total_tests) {
    data.completed_tests = data.total_tests
  }

  return (
    <Link to={`/course/${data.id}`}>
      <div className="tableCoursesRow__container">
        <div className="tableCoursesRow__nameContainer">
          <img
            src={data.image || ''}
            alt=""
            className="tableCoursesRow__image"
          ></img>
          <div className="tableCoursesRow__name">{data.title}</div>
        </div>
        <div className="tableCoursesRow__resultContainer">
          <div className="tableCoursesRow__progress">{`${data.completed_tests}/${data.total_tests}`}</div>
          <div className="tableCoursesRow__average">
            {data.avg > 100 ? '100%' : data.avg + '%'}
          </div>
          <div className="tableCoursesRow__group">
            {data.group_result > 100 ? '100%' : data.group_result + '%'}
          </div>
        </div>
      </div>
    </Link>
  )
}
export default TableCoursesRow
